import { useState } from 'react'
import { Row, Col, Typography, Button } from 'antd'
import { useNavigate } from 'react-router-dom'
import { createAuction } from '../../redux/actions/rosterAction'

const GmCard = ({ playerData, news }) => {
  const { team, Name, isActive, InjuryStatus, PositionRank, LeagueRank, PlayerID, _id } = playerData

  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleCreateAuction = async (playerID, player_id) => {
    setIsLoading(true)
    const res = await createAuction({
      PlayerID: playerID,
      player_id: player_id,
      auctionFrom: 'nonowner',
    })
    if (res) {
      navigate('/player-auction')
    }
    setIsLoading(false)
  }

  return (
    <section className='player_info_box_new'>
      <Row gutter={[30, 20]}>
        <Col xs={24} xl={10}>
          <div className='left'>
            <div>
              <Typography.Title level={2}>{Name}</Typography.Title>
              <div className='player-active-status'>
                <div className='active'>
                  <div className={isActive ? `active_btn` : 'in-active_btn'} />
                  <p>{isActive ? 'Active Player' : 'In-active Player'}</p>
                </div>
                <div className='injury-status'>
                  <p>Injury Status</p>
                  <h4>{InjuryStatus || '-'}</h4>
                </div>
              </div>
            </div>
            <div className='box'>
              <p className='text1'>Position Rank:</p>
              <p className='text2'>#{PositionRank > 0 ? PositionRank : 0}</p>
            </div>
            <div className='box'>
              <p className='text1'>League Rank:</p>
              <p className='text2'>#{LeagueRank > 0 ? LeagueRank : 0}</p>
            </div>
          </div>
        </Col>
        <Col xs={24} xl={14}>
          <Button
            type='primary'
            style={{ marginTop: '25px', marginLeft: 'auto', display: 'flex' }}
            loading={isLoading}
            onClick={() => {
              handleCreateAuction(PlayerID, _id)
            }}
          >
            AUCTION PLAYER
          </Button>
          <div className='player-news'>
            <Typography.Title level={3}>{`Player News`}</Typography.Title>
            <p>{news}</p>
          </div>

          <div className='stats-bar'>
            <div className='player-news'>
              <p>Past Year Stats Bar</p>
              <div className='years'>
                <Typography.Title level={2}>2023</Typography.Title>
                <Typography.Title level={2}>2022</Typography.Title>
                <Typography.Title level={2}>2021</Typography.Title>
              </div>
            </div>
            {team != null && team?.logo && <img src={team?.logo} height={'100px'} />}
          </div>
        </Col>
      </Row>
    </section>
  )
}

export default GmCard
